// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import AdminServices from "services/AdminServices";

// const SelectState = ({
//   onSelectState,
//   name,
//   label,
//   selectedServiceState = [],
//   setSelectedServiceState,
//   register,
//   required,
// }) => {
//   const [states, setStates] = useState([]);
//   const [allSelected, setAllSelected] = useState(false);

//   // Fetch states on component mount

//   useEffect(() => {
//     // console.log(process.env.REACT_APP_API_BASE_URL)
//     const fetchStates = async () => {
//       try {
//         const response = await AdminServices.getAllState();
//         if (Array.isArray(response.data)) {
//           setStates(
//             response.data.map((state) => ({
//               value: state.id_state,
//               label: state.name,
//             }))
//           );
//         } else {
//           console.error("API Response is not an array:", response);
//         }
//       } catch (error) {
//         console.error("Error fetching states:", error);
//       }
//     };

//     fetchStates();
//   }, []);

//   // Get selected options for react-select
//   const getSelectedOptions = () => {
//     return selectedServiceState
//       .map((value) =>
//         states.find((state) =>
//           typeof value === "object"
//             ? state.value === value.value
//             : state.value.toString() === value.toString()
//         )
//       )
//       .filter(Boolean);
//   };

//   // Handle selection changes
//   const handleStateSelect = (selectedOptions) => {
//     const isSelectAllSelected = selectedOptions.some(
//       (option) => option.value === "select_all"
//     );
//     if (isSelectAllSelected) {
//       const allStates = states.map((state) => ({
//         value: state.value,
//         label: state.label,
//       }));
//       setSelectedServiceState(allStates); // Select all states
//       onSelectState(allStates); // Notify parent of the change
//       setAllSelected(true);
//     } else {
//       setSelectedServiceState(selectedOptions); // Update parent state
//       onSelectState(selectedOptions); // Notify parent of the change
//       setAllSelected(false);
//     }
//   };

//   const options = [
//     { value: "select_all", label: "Select All States" },
//     ...states,
//   ];

//   const customStyles = {
//     indicatorsContainer: (provided) => ({
//       ...provided,
//       padding: "0", // Optional: Adjust padding
//     }),
//     indicatorSeparator: () => ({
//       display: "none", // Removes the separator line
//     }),
//   };

//   return (
//     <div>
//       {label && <label className="block text-sm font-medium">{label}</label>}
//       <Select
//         {...register(`${name}`, {
//           ...(required && {
//             required: `${label} is required!`,
//           }),
//         })}
//         isMulti
//         name={name}
//         options={options} // Include "Select All" option
//         value={allSelected ? states : getSelectedOptions()} // Pre-select values
//         onChange={handleStateSelect} // Handle changes
//         placeholder="Select States"
//         classNamePrefix="react-select"
//         className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
//         styles={customStyles}
//       />
//     </div>
//   );
// };

// export default SelectState;



import React, { useEffect, useState } from "react";
import Select from "react-select";
import AdminServices from "services/AdminServices";

const SelectState = ({
  onSelectState,
  name,
  label,
  selectedServiceState = [],
  setSelectedServiceState,
  register,
  required,
  showClearAllButton = false,
}) => {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await AdminServices.getAllState();

        if (Array.isArray(response.data)) {
          const stateOptions = response.data.map((state) => ({
            value: state.id_state,
            label: state.name,
          }));

          setStates(stateOptions);
        } else {
          console.error("API Response is not an array:", response);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  const getSelectedOptions = () => {
    return selectedServiceState
      .map((selectedState) => {
        const selectedValue =
          typeof selectedState === "object"
            ? selectedState.value
            : selectedState;

        return states.find(
          (state) =>
            String(state.value) === String(selectedValue)
        );
      })
      .filter(Boolean);
  };

  const handleStateSelect = (selectedOptions) => {
    const selected = selectedOptions || [];

    const isSelectAllSelected = selected.some(
      (option) => option.value === "select_all"
    );

    if (isSelectAllSelected) {
      const allStates = states.map((state) => ({
        value: state.value,
        label: state.label,
      }));

      setSelectedServiceState(allStates);
      onSelectState(allStates);

      return;
    }

    setSelectedServiceState(selected);
    onSelectState(selected);
  };

  const handleClearAll = () => {
    setSelectedServiceState([]);
    onSelectState([]);
  };

  const options = [
    {
      value: "select_all",
      label: "Select All States",
    },
    ...states,
  ];

  const selectedOptions = getSelectedOptions();

  const allStatesSelected =
    states.length > 0 &&
    selectedOptions.length === states.length;

  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

return (
  <div className="w-full">
    {label && (
      <label className="block text-sm font-medium mb-1">
        {label}
      </label>
    )}

    <div className="w-full">
      <Select
        {...register(`${name}`, {
          ...(required && {
            required: `${label} is required!`,
          }),
        })}
        isMulti
        name={name}
        options={options}
        value={selectedOptions}
        onChange={handleStateSelect}
        placeholder="Select States"
        classNamePrefix="react-select"
        className="w-full"
        styles={customStyles}
        isClearable={false}
      />
    </div>

    {showClearAllButton && selectedOptions.length > 0 && (
      <div className="flex justify-end mt-2">
        <button
          type="button"
          onClick={handleClearAll}
          className="px-3 py-1 text-sm font-medium text-red-600 border border-red-300 rounded hover:bg-red-50"
        >
          Clear All
        </button>
      </div>
    )}
  </div>
);
};

export default SelectState;